import React, { Component } from "react";

import { createMuiTheme, MuiThemeProvider } from "@material-ui/core/styles";
import LoadingBar from "react-top-loading-bar";
import API from "../../../../Services/Api";
import { checkResponseError } from "../../../../Services/Utils";
import { connect } from "react-redux";
import * as R from "ramda";
import { Redirect } from "react-router-dom";
import AuthAction from "../../../../Redux/AuthRedux";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import M from "moment";
import DDLCompany from "../../../../modules/commons/DDLCompany";
import Button from "../../../../modules/commons/Button";

const UtilsButtonLogin = require("../../../../Services/UtilsButtonLogin");

const ct = require("../../../../modules/custom/customTable");
const getMuiTheme = () => createMuiTheme(ct.customTable());
const options = ct.customOptions6();

class ReportH1 extends Component {
  constructor() {
    super();
    this.state = {
      accordionOpen: false,
      accordionOpen2: false,
      rawData: [],
      dataTable: [],
      dataTable: [],
      selectedIndex: [],
      allowResize: false,
      defaultSize: 0,
      minSize: 0,
      maxSize: 0,
      timeout: 1000 * 100 * 9,
      isTimedOut: false,
      toCount: 0,
      table_limit: 10,
      table_page: 0,
      table_query: "",
      createVisible2: false,
      tabIndex: 0,
      checkTab: false,
      data: {},
      dataDto: {},
      buttonAccess: {},
    };
    this.idleTimer = null;
  }

  logout() {
    this.props.authLogout();
    return <Redirect to={{ pathname: "/" }} />;
  }

  onAction() {
    this.setState({ isTimedOut: false });
  }

  onActive() {
    this.setState({ isTimedOut: false });
  }

  handleToggleAccordion = () => {
    this.setState({ accordionOpen: !this.state.accordionOpen });
  };
  handleToggleAccordion2 = () => {
    this.setState({ accordionOpen2: !this.state.accordionOpen2 });
  };

  onIdle() {
    const isTimedOut = this.state.isTimedOut;
    if (isTimedOut) {
      alert("Your session has timed out. Please log in again");
      this.logout();
    } else {
      this.idleTimer.reset();
      this.setState({ isTimedOut: true });
    }
  }

  componentDidMount() {
    UtilsButtonLogin.buttonAccess("MASTER-022", (response) => {
      // console.log("ORI ", response);
      this.setState(
        {
          buttonAccess: response,
        },
        () => {
          this.getCountPage(this.state.table_page, this.state.table_limit);
        }
      );
    });
  }

  getCountPage = async (page, limit) => {
    let payload = {
      limit: limit,
      offset: page,
      filter: this.state.table_query,
      companyId: this.state.dataDto.companyId,
      companyGroupId: null,
      category: null,
      isActive: null,
      sortBy: this.state.dataDto.sortBy ?? "",
      orderBy: this.state.dataDto.orderBy ?? "",
    };

    let res = await API.create("LOCAL_DELIVERY").getDelivery(payload);
    if (res.ok) {
      if (res.data.data === null) {
        this.setState({ dataTable: [] });
      } else {
        // console.log(JSON.stringify(res.data.data, null, 2));
        let dataTable =
          res.data.data &&
          res.data.data.map((value) => {
            const {
              noid,
              nospk,
              namacustomer,
              tgldelivery,
              unittype,
              warna,
              noka,
              nosin,
              nopickship,
            } = value;
            return [
              noid,
              nospk,
              namacustomer,
              tgldelivery,
              unittype,
              warna,
              noka,
              nosin,
              nopickship,
            ];
          });
        console.log("datatable", dataTable);
        this.setState({
          rawData: res.data.data && res.data.data.listUser,
          dataTable,
          toCount: res.data.data && res.data.data.dataOfRecord,
        });
        this.onFinishFetch();
      }
    }
  };

  handleClearUser = (e) => {
    this.setState(
      {
        table_page: 0,
        toCount: 0,
        data: {},
        dataDto: {},
      },
      () => {
        this.getCountPage(this.state.table_page, this.state.table_limit);
      }
    );
  };

  handleSearch = (eventSearch) => {
    this.setState(
      {
        table_page: 0,
        dataDto: eventSearch ? this.state.data : this.state.dataDto,
      },
      () => {
        this.getCountPage(this.state.table_page, this.state.table_limit);
      }
    );
  };

  isLoad(visible) {
    this.setState({ loadSave: visible });
  }

  checkResponse(res, type) {
    if (res.ok && res.data.status === "S") {
      type === "delete" && this.setState({ deletePopUpVisible: false });
      setTimeout(() => {
        this.openSavePopUp();
      }, 500);
    } else {
      this.isLoad(false);
      checkResponseError(res);
    }
  }

  handleSubmit = async (response) => {
    this.checkResponse(response);
  };

  handleDelete = async () => {
    this.isLoad(true);
    let payload = { ...this.state.rawData[this.state.selectedIndex] };
    payload.action = "DELETE";

    let response = await API.create("MASTERDATA_EKSAD").postSaveUser(payload);
    this.checkResponse(response, "delete");
    this.isLoad(false);
  };

  handlePopUp = () => {
    this.handleSearch();
    this.setState({
      savePopUpVisible: false,
      createVisible: false,
      createVisible2: false,
    });
  };

  onChangeDate = (e, name) => {
    this.setState({
      data: {
        ...this.state.data,
        [name]: M(e).format("DD-MM-YYYY"),
      },
    });
  };

  startFetch = () => {
    this.LoadingBar.continousStart();
  };

  onFinishFetch = () => {
    if (typeof this.LoadingBar === "object") this.LoadingBar.complete();
  };

  onchangeInput = (event) => {
    let name = event.target.name;
    let value = event.target.value;
    this.setState({
      data: {
        ...this.state.data,
        [name]: value,
      },
    });
  };

  opSidePage = (menu, data) => (e) => {
    e.preventDefault();
    let selectedIndex = data;
    this.setState({
      updateVisible: false,
    });

    switch (menu) {
      case "slide-menu-1":
        this.setState({
          updateVisible: true,
          selectedIndex,
          popupType: "update",
        });
        break;
      case "slide-menu-view":
        this.setState({
          updateVisible: true,
          selectedIndex,
          popupType: "view",
        });
        break;
      default:
        break;
    }
  };

  resetTab = (tabIndex) => {
    this.setState({ tabIndex });
    if (tabIndex === 0) {
      this.getCountPage(this.state.table_page, this.state.table_limit);
    }
  };

  render() {
    if (R.isNil(this.props.auth.user))
      return <Redirect to={{ pathname: "/" }} />;
    let { toCount, table_query } = this.state;
    let tableOptions = {
      ...options,
      // serverSide: true,
      filter: false,
      count: toCount,
      searchText: table_query,
      search: false,
      viewColumns: false,
      rowsPerPage: this.state.table_limit,
      page: this.state.table_page,

      onTableChange: (action, tableState) => {
        switch (action) {
          case "changePage":
            this.setState({ table_page: tableState.page });
            this.getCountPage(tableState.page, tableState.rowsPerPage);
            break;
          case "changeRowsPerPage":
            this.setState({ table_limit: tableState.rowsPerPage });
            this.getCountPage(tableState.page, tableState.rowsPerPage);
            break;
          case "search":
            let searchText = tableState.searchText ? tableState.searchText : "";
            this.setState({ table_query: searchText }, () => {
              this.handleSearch();
            });
            break;
          default:
            break;
        }
      },
    };

    return (
      <div className="main-slider">
        <div className="padding-tbl-monitoring">
          <LoadingBar onRef={(ref) => (this.LoadingBar = ref)} />
          <Tabs
            selectedIndex={this.state.tabIndex}
            onSelect={(tabIndex) => this.resetTab(tabIndex)}
          >
            <TabList>
              <Tab>REPORT H1</Tab>
            </TabList>
            <TabPanel>
              {/* container1 */}
            <div 
            style={{backgroundColor:"red",}}
            className="accordion">
              <div  style={{display:"flex", justifyContent:"space-between", padding:"15px"}}>

            <h4>1. Laporan Penjualan Parts</h4>
                <div
                
                className="accordion-header"
                onClick={this.handleToggleAccordion}
                >
                  
                  <button className="toggle-button">
                    {this.state.accordionOpen ? "Expand" : "Collapse"}
                  </button>
                </div>
                </div>
                {this.state.accordionOpen && (
                  <div 
                  style={{display:"flex", paddingLeft:"15px", paddingRight:"15px"}}
                  className="accordion-content">
                    <div className="padding-15px grid grid-2x grid-mobile-none gap-15px">
                <div className="column-1">{this.renderForm()}
                <Button
                    type="button"
                    style={{ width: "200px" }}
                    className="btn btn-plus background-red margin-bottom-15px "
                    valueCombo={this.state.data.companyIdSelect}
                    // onClick={this.openCreateForm.bind(this)}
                  >
                    <span>
                      <i
                        className="fa fa-download"
                        style={{ marginRight: "10px" }}
                      />
                      Download
                    </span>
                  </Button>
                  </div>
                <div className="column-2">{this.renderForm2()}
                </div>
                </div>
                
                  </div>
                )}
              </div>
               {/* container2 */}
            <div 
            style={{backgroundColor:"red", marginTop: "10px"}}
            className="accordion">
              <div  style={{display:"flex", justifyContent:"space-between", padding:"15px"}}>

            <h4>2. Laporan Cash Bank Report</h4>
                <div
                
                className="accordion-header"
                onClick={this.handleToggleAccordion2}
                >
                  
                  <button className="toggle-button">
                    {this.state.accordionOpen2 ? "Expand" : "Collapse"}
                  </button>
                </div>
                </div>
                {this.state.accordionOpen2 && (
                  <div 
                  style={{display:"flex", paddingLeft:"15px", paddingRight:"15px"}}
                  className="accordion-content">
                    <div className="padding-15px grid grid-2x grid-mobile-none gap-15px">
                <div className="column-1">{this.renderForm()}
                <Button
                    type="button"
                    style={{ width: "200px" }}
                    className="btn btn-plus background-red margin-bottom-15px "
                    valueCombo={this.state.data.companyIdSelect}
                    // onClick={this.openCreateForm.bind(this)}
                  >
                    <span>
                      <i
                        className="fa fa-download"
                        style={{ marginRight: "10px" }}
                      />
                      Download
                    </span>
                  </Button>
                  </div>
                <div className="column-2">{this.renderForm2()}
                </div>
                </div>
                
                  </div>
                )}
              </div>
            </TabPanel>
          </Tabs>
        </div>
      </div>
    );
  }

  renderForm() {
    return (
<div style={{width:400}}>
                    <DDLCompany
                        label={"Kategori"}
                        box={"search"}
                        hierarchy={false}
                        onChangeCombo={(value) => {
                          this.setState({
                            data: { ...this.state.data, ...value },
                          });
                        }}
                        valueCombo={this.state.data.companyIdSelect}
                      />
                      <DDLCompany
                        label={"WareHouse"}
                        box={"search"}
                        hierarchy={false}
                        onChangeCombo={(value) => {
                          this.setState({
                            data: { ...this.state.data, ...value },
                          });
                        }}
                        valueCombo={this.state.data.companyIdSelect}
                      />
                      <DDLCompany
                        label={"Locator"}
                        box={"search"}
                        hierarchy={false}
                        onChangeCombo={(value) => {
                          this.setState({
                            data: { ...this.state.data, ...value },
                          });
                        }}
                        valueCombo={this.state.data.companyIdSelect}
                      />
                     
                  </div>
)
}
renderForm2() {
  return (
<div style={{width:400}}>
                  <DDLCompany
                      label={"Kriteria Laporan"}
                      box={"search"}
                      hierarchy={false}
                      onChangeCombo={(value) => {
                        this.setState({
                          data: { ...this.state.data, ...value },
                        });
                      }}
                      valueCombo={this.state.data.companyIdSelect}
                    />
                    <DDLCompany
                        label={"Sub Inventory"}
                        box={"search"}
                        hierarchy={false}
                        onChangeCombo={(value) => {
                          this.setState({
                            data: { ...this.state.data, ...value },
                          });
                        }}
                        valueCombo={this.state.data.companyIdSelect}
                      />
                      
                       <div 
                  style={{display:"flex", justifyContent:"space-between"}}
                  className="accordion-content">
                    <div className="grid grid-2x grid-mobile-none gap-15px">
                <div className="column-1">
                <DDLCompany
                        label={"Sub Inventory"}
                        box={"search"}
                        hierarchy={false}
                        onChangeCombo={(value) => {
                          this.setState({
                            data: { ...this.state.data, ...value },
                          });
                        }}
                        valueCombo={this.state.data.companyIdSelect}
                      />
                  </div>
                <div className="column-2">
                <DDLCompany
                        label={"Sub Inventory"}
                        box={"search"}
                        hierarchy={false}
                        onChangeCombo={(value) => {
                          this.setState({
                            data: { ...this.state.data, ...value },
                          });
                        }}
                        valueCombo={this.state.data.companyIdSelect}
                      />         
                </div>
                </div>
                
                  </div>
          
                </div>
)
}
}


const mapStateToProps = (state) => {
  return {
    h1Module: state.h1Module,
    auth: state.auth,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    authLogout: () => dispatch(AuthAction.authLogout()),
  };
};



export default connect(mapStateToProps, mapDispatchToProps)(ReportH1);
